module.exports = __webpack_public_path__ + "img/LegendOfChange_EGM.ec47e5d1.png";